export default __webpack_public_path__ + "assets/apple-icon-144x144.a996d40b301f11c8339881e156ab98a0.png";